module.exports = __webpack_public_path__ + "static/media/iphone_13_pro_graphite.214cb320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_pro_graphite.png
// module id = 2120
// module chunks = 0